module.exports = __webpack_public_path__ + "img/menu.aa7ee8b9.svg";